import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Alert
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FixedWingSinglePilot = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Single Pilot Operation (Para 8)</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            Single pilot operation limits based on D7J-J4-Fixed Wing.pdf Para 8.1.1 and 8.1.2.
          </Typography>
        </Alert>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>Para 8.1.1</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time"
              type="number"
              value={baseline.maxFlightTimeSinglePilot7Hrs}
              onChange={(e) => handleChange('maxFlightTimeSinglePilot7Hrs', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 10, step: 0.5 }}
              helperText="Para 8.1.1: 7 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP"
              type="number"
              value={baseline.maxFDPSinglePilot7Hrs}
              onChange={(e) => handleChange('maxFDPSinglePilot7Hrs', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 12, step: 0.5 }}
              helperText="Para 8.1.1: 08:30"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Landings"
              type="number"
              value={baseline.maxLandingsSinglePilot7Hrs}
              onChange={(e) => handleChange('maxLandingsSinglePilot7Hrs', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 10, step: 1 }}
              helperText="Para 8.1.1: 8 landings"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>Para 8.1.2</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time"
              type="number"
              value={baseline.maxFlightTimeSinglePilot8Hrs}
              onChange={(e) => handleChange('maxFlightTimeSinglePilot8Hrs', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 10, step: 0.5 }}
              helperText="Para 8.1.2: 8 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP"
              type="number"
              value={baseline.maxFDPSinglePilot8Hrs}
              onChange={(e) => handleChange('maxFDPSinglePilot8Hrs', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 12, step: 0.5 }}
              helperText="Para 8.1.2: 09:30"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Landings"
              type="number"
              value={baseline.maxLandingsSinglePilot8Hrs}
              onChange={(e) => handleChange('maxLandingsSinglePilot8Hrs', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 10, step: 1 }}
              helperText="Para 8.1.2: 6 landings"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>Per Sector Limits (Note 2)</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Max Flight Time (With Autopilot)"
              type="number"
              value={baseline.maxFlightTimePerSectorWithAutopilot}
              onChange={(e) => handleChange('maxFlightTimePerSectorWithAutopilot', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 6, step: 0.5 }}
              helperText="Para 8 Note 2: 4 hrs per sector"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Max Flight Time (Without Autopilot)"
              type="number"
              value={baseline.maxFlightTimePerSectorWithoutAutopilot}
              onChange={(e) => handleChange('maxFlightTimePerSectorWithoutAutopilot', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 4, step: 0.5 }}
              helperText="Para 8 Note 2: 2 hrs per sector"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FixedWingSinglePilot;
